import {
  Button,
  GreyGrey10,
  GreyGrey70,
  Primary13Regular,
  Primary14SemiBold,
  Box,
  Grid,
  GridItem
} from '@sequencehq/core-components'
import { useInstructions } from './useInstructions'

export const Instructions = () => {
  const hook = useInstructions()

  return (
    <Grid
      width="100%"
      gridTemplateColumns="1fr auto"
      height="68px"
      padding="16px"
      alignItems="center"
      backgroundColor={GreyGrey10}
      borderRadius="8px"
      color={GreyGrey70}
      userSelect="none"
    >
      <GridItem display="grid" gridTemplateRows="auto auto" gridGap="4px">
        <Box {...Primary14SemiBold}>Browse connectors</Box>
        <Box {...Primary13Regular}>Select a connector to get started</Box>
      </GridItem>
      <GridItem display="flex" alignItems="center" justifyContent="flex-end">
        <Button
          variant="secondary"
          onClick={hook.documentation.onClick}
          data-testid="integrations.instructions.learnMore"
        >
          Learn more
        </Button>
      </GridItem>
    </Grid>
  )
}
